import React, { useEffect, useState } from 'react';
import { generateMockPaper, generateStudyGuide, generateImportantTopics, generateExamExpectations } from '../services/api';
import LoadingSpinner from './LoadingSpinner';
import ErrorMessage from './ErrorMessage';
import ResourceDisplay from './ResourceDisplay';

const apiMap = {
  mockPaper: generateMockPaper,
  studyGuide: generateStudyGuide,
  importantTopics: generateImportantTopics,
  examExpectations: generateExamExpectations,
};

const OutputPanel = ({ currentDocument, activeTab, generationResults, setGenerationResults }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!currentDocument || !activeTab) return;
    if (generationResults && generationResults[activeTab]) return;
    const apiFn = apiMap[activeTab];
    if (!apiFn) return;
    setLoading(true);
    setError('');
    apiFn({ documentId: currentDocument.documentId })
      .then(res => {
        const data = res.data || res;
        // Unwrap if the response is an object with a single key
        const value = typeof data === 'object' && data !== null && Object.keys(data).length === 1
          ? Object.values(data)[0]
          : data;
        setGenerationResults(prev => ({ ...prev, [activeTab]: value }));
      })
      .catch(err => {
        setError(err?.message || 'Failed to generate result.');
      })
      .finally(() => setLoading(false));
  }, [activeTab, currentDocument, setGenerationResults, generationResults]);

  return (
    <div className="glass-card shadow-lg p-8 mb-8 rounded-2xl font-sans text-gray-900">
      <div className="py-4 min-h-[80px] leading-relaxed">
        {!currentDocument && <div className="text-gray-500">Select or upload a document to get started.</div>}
        {currentDocument && loading && <LoadingSpinner />}
        {currentDocument && error && <ErrorMessage message={error} />}
        {currentDocument && !loading && !error && generationResults[activeTab] && (
          <ResourceDisplay resource={generationResults[activeTab] || null} />
        )}
      </div>
    </div>
  );
};

export default OutputPanel; 